import * as React from "react";
import { connect } from "react-redux";
import { getVal, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import Input from "../input/input";
import translate from "../../translations/i18n";
import hidden_pass from "../../icons/hidden.svg";
import visible_pass from "../../icons/visible.svg";
import CtaButton from "../ctaButton/ctaButton";
import "../../style/fonts.css";
import "./ResetPassword.css";
import ResetPasswordError from "./ResetPasswordError";
import firebase from 'firebase/app'
import { Redirect } from "react-router-dom";

export interface Props {
  password: string;
  seePassword: boolean;
}

interface State {
  codeVerified: boolean;
  checkedCode: boolean;
  openNextPage: boolean;
}

class ResetPassword extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = {
      password: "",
      seePassword: false,
      codeVerified: false,
      checkedCode: false,
      openNextPage: false,
    };
    this.checkCode = this.checkCode.bind(this);
  }
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.checkCode();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChangePass(event) {
    this.setState({ password: event.target.value });
  }

  showEye() {
    if (this.state.seePassword) return <img src={hidden_pass} />;
    else return <img src={visible_pass} />;
  }

  passSeen() {
    this.setState((prevState) => ({
      seePassword: !prevState.seePassword,
    }));
  }

  getUrlVars() {
    let result = " ";
    let parts = [];
    try {
      parts = window.location.href.split("&");
    } catch (err) {
      console.log(err);
    }
    parts.forEach(function (element) {
      if (element.includes("oobCode=")) {
        result = element.split("=")[1];
      }
    });

    console.log("Result: " + result);
    return result;
  }

  checkCode() {
    firebase
      .auth()
      .verifyPasswordResetCode(this.getUrlVars())
      .then(() => {
        this.setState({
          codeVerified: true,
          checkedCode: true,
          resetCode: this.getUrlVars(),
        });
      })
      .catch(() => {
        this.setState({ codeVerified: false, checkedCode: true });
      });
  }

  handleClick = () => {
    if (this.state.password.length < 8) {
      this.setState({ passwordError: "PASSWORD_FORM_TOO_SHORT" });
    } else {
      this.submitNewPassword();
    }
  };

  submitNewPassword = async () => {
    firebase
      .auth()
      .confirmPasswordReset(this.state.resetCode, this.state.password)
      .then(() => {
        if (this._isMounted) {
          console.log(this._isMounted);
          this.setState({ openNextPage: true });
        }
      })
      .catch((error) => {
        if (error.code == "auth/weak-password" && this._isMounted) {
          this.setState({ passwordError: "PASSWORD_FORM_TOO_SHORT" });
        }
      });
  };

  render() {
    if (this.state.openNextPage) {
      return <Redirect to={`/resetPasswordSuccess`} push />;
    }
    if (this.state.checkedCode) {
      if (this.state.codeVerified) {
        return (
          <div className="reset-password-cont">
            <div className="reset-password-cont-center">
              <div className="reset-password__headline">
                <div className="TITLE_2">
                  {translate("NEW_PASSWORD_WEB_TITLE")}
                </div>
              </div>
              <div className="reset-password__text">
                <div className="REG_TEXT ">
                  {translate("NEW_PASSWORD_WEB_TEXT")}
                </div>
              </div>
              <div className="reset-password__password-input-cont">
                <Input
                  type={"password"}
                  placeholder={translate("NEW_PASSWORD_WEB_FORM")}
                  value={this.state.password}
                  onChange={this.handleChangePass.bind(this)}
                  warning={
                    this.state.passwordError &&
                    translate(this.state.passwordError)
                  }
                  passwordSeen={this.state.seePassword}
                />
                <div className="PASS_ICON" onClick={this.passSeen.bind(this)}>
                  {this.showEye()}
                </div>
              </div>
              <div
                className="reset-password__button-cont"
                onClick={this.handleClick}
              >
                <CtaButton
                  width={"280px"}
                  text={translate("CTA_NEW_PASSWORD_WEB")}
                  color={"white"}
                />
              </div>
            </div>
          </div>
        );
      } else {
        return <ResetPasswordError />;
      }
    } else {
      return null;
    }
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/resetPassword/ResetPassword.tsx